import type { ISerialize } from '@/objects/ISerialize';
import { formatDateIso } from '@/utilities/dateutils';

export class User2FACode implements ISerialize {
    public readonly Code: string | null;

    public DisableTwoFactor: boolean;

    public Expires: Date;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { Code?: string | null; DisableTwoFactor?: boolean; Expires?: Date }) {
        this.Code = values.Code ?? '';

        this.DisableTwoFactor = values.DisableTwoFactor ?? false;

        this.Expires = values.Expires ?? new Date('1970-01-01T00:00:00.000');
    }

    public serialize(): string {
        return (
            '{' +
            `"Code": ${JSON.stringify(this.Code)}` +
            ',' +
            `"DisableTwoFactor": ${JSON.stringify(this.DisableTwoFactor)}` +
            ',' +
            `"Expires": ${'"' + formatDateIso(this.Expires) + '"'}` +
            '}'
        );
    }

    /**
     * Creates an instance of User2FACode from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { DisableTwoFactor?: boolean; Expires?: Date }): User2FACode {
        return new User2FACode(values);
    }

    public static _FromServerJson(json: any): User2FACode {
        return new User2FACode({
            Code: json.Code ?? '',
            DisableTwoFactor: json.DisableTwoFactor,
            Expires: json.Expires instanceof Date ? json.Expires : new Date(json.Expires),
        });
    }

    /**
     * Creates an instance of User2FACode from another instance of User2FACode.
     * @param other The User2FACode you want to clone
     * @returns A cloned User2FACode
     */
    public static FromOther(other: User2FACode): User2FACode {
        return User2FACode._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return User2FACode.FromOther(this);
    }

    static NAME_OF_CLASS = 'User2FACode';
}
